import { jsx as _jsx } from "react/jsx-runtime";
import { Modal, View } from 'react-native';
import { CoreConfig } from '../../../CoreConfig';
import { component } from '../../Decorators/Component';
import { Configuration } from '../../../Domain/DTOs/Configuration/ConfigurationDTO';
import { getColorScheme } from '../../Hooks/UseColorScheme';
import { useDirection } from '../../Hooks/UseDirection';
export const SidebarView = component({
    provider: CoreConfig.provider,
    moduleName: CoreConfig.moduleName,
    componentName: Configuration.ComponentNames.sidebar,
    style(theme, mediaQuery, window, props) {
        return {
            modal: {
                height: '100%',
                backgroundColor: 'rgba(0, 0, 0, 0.4)'
            },
            container: Object.assign({ height: '100%', backgroundColor: getColorScheme().value.colors.background }, mediaQuery.md({
                width: '100%',
                maxWidth: 435,
                alignSelf: props.align === 'right'
                    ? 'flex-end'
                    : 'flex-start'
            }))
        };
    }
})(({ style, visible, children }) => {
    const [dir] = useDirection();
    return (_jsx(Modal, { visible: visible, transparent: true, hardwareAccelerated: true, animationType: "fade", dir, children: _jsx(View, { style: style === null || style === void 0 ? void 0 : style.modal, children: _jsx(View, { style: style === null || style === void 0 ? void 0 : style.container, children: children }) }) }));
});
